<template>
    <IntegrationDetailDialog
        gradient="zaptime-gradient"
        :requires-sub="true"
        v-model:open="detailDialogOpen"
    >
        <template #icon>
            <Webhook :size="56" />
        </template>

        <template #title>{{ $t("integrations.webhook.title") }}</template>

        <template #short-description>
            {{ $t("integrations.webhook.description") }}
        </template>
        <template #description>
            {{ $t("integrations.webhook.long_description") }}
        </template>
        <template #cta>
            <WebhookIntegrationModal
                @integration-created="handleIntegrationCreated"
            >
                <Button type="submit" class="gap-2">
                    <Plus :size="20"></Plus>
                    {{ $t("integrations.detail_modal.add_integration") }}
                </Button>
            </WebhookIntegrationModal>
        </template>
    </IntegrationDetailDialog>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import IntegrationDetailDialog from "../IntegrationDetailDialog.vue";
import { Button } from "@/components/ui/button";
import { Plus, Webhook } from "lucide-vue-next";

import WebhookIntegrationModal from "../AddOrUpdateModals/WebhookIntegrationModal.vue";

const emit = defineEmits<{
    integrationCreated: [];
}>();

const detailDialogOpen = ref(false);

function handleIntegrationCreated() {
    // Close this detail dialog
    detailDialogOpen.value = false;
    // Emit to parent (AddIntegrationModal) to close it too
    emit("integrationCreated");
}
</script>
